import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "../../../ui/theme/colors";

export const LoaderFC = (props) => {
  useEffect(() => {}, []);

  return (
    <LoaderSC>
      <SpinnerWrapper>
        <Spinner />
        <SpinnerInner />
      </SpinnerWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 664 112">
        <title>Avante Health Solutions</title>
        <path d="M455.8,49.7V28a7.19,7.19,0,0,1-3.5.8H438.5c-1.8,0-3.7.7-3.7,2v19H431V6.3h3.8V25.7a6.71,6.71,0,0,1,3.7-.8H452c1.7,0,3.7-.4,3.7-2V6.3h3.8V49.7ZM466,34c0-8.9,5.8-16.6,13.6-16.6,6.1,0,10.4,3.5,10.4,8.1,0,5-4.9,8.7-11.6,8.7H471c-.9,0-1,.9-1,1.3,0,4.6,4.5,10.4,9.7,10.4,3.1,0,5.5-1,8-4.4l3,2.3c-2.6,3.6-5.6,6-11.1,6C471.4,49.7,466,42.3,466,34Zm4-3.6a2.77,2.77,0,0,1,.9-.1h7.4c4.8,0,7.9-2.1,7.9-4.9,0-1.9-1.8-4.3-6.5-4.3s-8.5,3.9-9.7,9.3ZM495,40c0-5.5,5.4-9.7,11.7-9.7h6.6a1.24,1.24,0,0,0,1.3-1.2V27c0-3.1-3.2-5.9-7.5-5.9a7.78,7.78,0,0,0-6.4,2.9l-1.1,1.5-3-2.3,1.1-1.5a11.66,11.66,0,0,1,9.5-4.4c6,0,11.2,4.4,11.2,9.7V40c0,5.5-5.4,9.7-11.7,9.7S495,45.4,495,40Zm11.6-5.8c-4.3.1-7.9,2.6-7.9,5.8s3.6,5.9,7.9,5.9,7.9-2.8,7.9-5.9V33.9a6.75,6.75,0,0,1-1.4.2ZM525.4,6.3h3.8V49.7h-3.8Zm26.5,39.6h.5v3.8h-.5c-6.4,0-11.7-5.7-11.7-12.5V6.3H544V18.1a9.85,9.85,0,0,1,1.7-.2h6.8v3.8h-6.8c-1.7,0-1.7.8-1.7,1.2V37.2C544,42.1,547.5,45.9,551.9,45.9Zm31.4-15.7V49.7h-3.8V30.2c0-4.8-3.6-8.6-7.9-8.6h-6.5a6.6,6.6,0,0,1-1.4-.1V49.8h-3.8V6.3h3.8v9.8c0,1.7,1.1,1.7,1.2,1.7h6.6C578,17.8,583.3,23.6,583.3,30.2ZM445.2,105.7a23.77,23.77,0,0,1-9.5-1.6,14.94,14.94,0,0,1-5.4-4.3l-1.2-1.5,3-2.3,1.1,1.5c1.8,2.3,4,4.4,11.9,4.4,7.2,0,11.5-3.4,11.5-8.7,0-4.8-4-6.2-11.7-8s-14.7-4.3-14.7-11.8c0-7.1,5.5-11.2,14.9-11.2a15.26,15.26,0,0,1,12,5.9l1.2,1.5-3,2.3-1.1-1.5a11.42,11.42,0,0,0-9-4.4c-7.5,0-11.1,2.5-11.1,7.4s4.1,6.3,11.8,8.2a38.67,38.67,0,0,1,9.6,3.2,9.54,9.54,0,0,1,5.1,8.4c0,8.2-6.8,12.5-15.3,12.5Zm19.4-16.2c0-8.9,6.3-16.1,14.1-16.1,8.5,0,14.1,7.9,14.1,16.1,0,9-6.3,16.2-14.1,16.2C470.3,105.7,464.6,97.8,464.6,89.5Zm3.8,0c0,6.9,4.7,12.5,10.3,12.5S489,96.4,489,89.5,484.3,77,478.7,77,468.4,82.5,468.4,89.5Zm32-27.2h3.8v43.4h-3.8Zm12.6,31V73.4h3.8V93.3c0,4.8,3.6,8.6,7.9,8.6s7.9-3.8,7.9-8.6V73.4h3.8V93.3c0,6.9-5.3,12.4-11.7,12.4S513,100.1,513,93.3Zm43.4,8.6h.5v3.8h-.5c-6.4,0-11.7-5.7-11.7-12.5V62.3h3.8V74.1a9.85,9.85,0,0,1,1.7-.2H557v3.8h-6.8c-1.7,0-1.7.8-1.7,1.2V93.2C548.5,98.1,552.1,101.9,556.4,101.9Zm10.7-39.6a2.8,2.8,0,0,1,2.8,2.8,2.69,2.69,0,0,1-2.7,2.7h0a2.67,2.67,0,0,1-2.7-2.6v-.1a2.52,2.52,0,0,1,2.6-2.8Zm-1.8,11.1h3.8v32.4h-3.8Zm10.3,16.1c0-8.9,6.3-16.1,14.1-16.1,8.5,0,14.1,7.9,14.1,16.1,0,9-6.3,16.2-14.1,16.2C581.2,105.7,575.6,97.8,575.6,89.5Zm3.8,0c0,6.9,4.7,12.5,10.3,12.5S600,96.4,600,89.5,595.3,77,589.7,77,579.4,82.5,579.4,89.5Zm50,16.2V85.8c0-4.8-3.6-8.6-7.9-8.6s-7.9,3.8-7.9,8.6v19.9h-3.8V85.8c0-6.9,5.3-12.4,11.7-12.4s11.7,5.6,11.7,12.4v19.9Zm10.5-5.9,3-2.3c2.3,3.1,3.7,4.4,9,4.4,4.8,0,7.5-2.2,7.5-5.7,0-3.3-3.6-4.1-7.8-5.2-5.8-1.5-10.6-3.5-10.6-9,0-5.2,4-8.6,10.2-8.6,3.7,0,7.3,1.2,10.8,5.9l-3,2.3c-3-3.9-5.5-4.5-8.1-4.5-3.8,0-6,2-6,4.9,0,3.4,3.6,4.3,7.8,5.3,5.6,1.4,10.6,3.3,10.6,8.8s-4.5,9.6-11.3,9.6C645.4,105.7,642.7,103.5,639.9,99.8Z"></path>
        <rect x="394.2" width="7" height="112"></rect>
        <path d="M.9,102.1l32-92.2H42l32.1,92H62.5L52.2,72.6a14.25,14.25,0,0,1-6.1,1l-18.8-.1c-4.7,0-6,2.5-6.1,3l-8.9,25.6ZM25.5,63.9a6.36,6.36,0,0,1,3.3-.7h15c3.6,0,4.5-1.3,4.5-1.3L37.5,30.2Zm71,38.2L70.7,32.8H82.5l18.7,49.7,18.4-49.7h11.8l-25.8,69.3Zm41.1-21.4c0-12.3,12.3-21.4,25.7-21.4h7.4c3.2,0,7.3-1.7,7.3-5.1,0-5.2-5.6-10.4-13.5-10.4-5.1,0-9.6,2-15.2,9.7l-8.9-6.6c5.5-9.1,15.6-14.1,24-14.1,13.2,0,24.6,9.6,24.6,21.4V80.7c0,12.2-12.2,21.4-25.6,21.4s-25.8-9.2-25.8-21.4m11.1-.1c0,5.4,6.4,10.5,14.6,10.5s14.6-5.2,14.6-10.5V68.3s-.9,1.9-14.6,1.8c-8.2,0-14.5,5.1-14.6,10.5m97.1,21.5V59.8c0-9-6.7-15.9-14.4-15.9S217,50.8,217,59.8v42.3H206V59.8c0-14.7,11.3-27,25.5-27,14,0,25.5,12.2,25.5,27v42.3ZM298.7,91h2.7v11h-2.7a24.82,24.82,0,0,1-18.3-8,27.44,27.44,0,0,1-7.3-19V9.9h11V34.6s.7-.9,2.8-.9h14.5v11H287.9c-1.8,0-3.6,1-3.6,2.7V74.8C284.1,84,290.8,91,298.7,91m13.4-22.5c0-18.2,11.8-35.7,29.4-35.7,13.2,0,22.9,7.6,22.9,18.2,0,11.5-11.4,19.2-25.5,19.2H327.2a2.89,2.89,0,0,0-3.1,2.6v.6c0,8.8,10,17.4,17.4,17.4,6,0,10.2-1.9,16-9.7l8.8,6.6c-5.9,8-13.2,14.3-24.6,14.3-17.4.1-29.7-16.1-29.6-33.5m11.5-7.7a6.73,6.73,0,0,1,4.7-1.6h10.6c9.2,0,14.4-4,14.4-8.2,0-2.7-2.7-7.2-11.7-7.2-8.2,0-15.4,6.7-18,17"></path>
      </svg>
      <LoadingText>Loading Application...</LoadingText>
      <LoadingSubtext>
        Please wait while we prepare your dashboard
      </LoadingSubtext>
    </LoaderSC>
  );
};

// Animations
const spin = keyframes`
   0% {
      transform: rotate(0deg);
   }
   100% {
      transform: rotate(360deg);
   }
`;

const pulse = keyframes`
   0%, 100% {
      opacity: 1;
   }
   50% {
      opacity: 0.5;
   }
`;

const LoaderSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.light_primary || "#ffffff"};

  svg {
    height: auto;
    width: 100%;
    max-width: 500px;
    margin: 24px 0;
    fill: ${({ theme, darkMode }) =>
      darkMode ? theme.dark_accent : theme.avante_dark_blue};
  }

  svg rect {
    fill: ${({ theme }) => theme.avante_light_blue};
  }

  @media screen and (max-width: 768px) {
    svg {
      max-width: 300px;
    }
  }
`;

const SpinnerWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
`;

const Spinner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(44, 90, 160, 0.1);
  border-top: 4px solid ${colors.primary.main};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const SpinnerInner = styled.div`
  position: absolute;
  top: 12.5px;
  left: 12.5px;
  right: 12.5px;
  bottom: 12.5px;
  border: 4px solid transparent;
  border-top: 4px solid ${colors.primary.light};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite reverse;
`;

const LoadingText = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: ${colors.neutral[700]};
  margin: 16px 0 8px 0;
  animation: ${pulse} 2s ease-in-out infinite;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

const LoadingSubtext = styled.p`
  font-size: 16px;
  color: ${colors.neutral[500]};
  margin: 0;
  font-weight: 400;
  text-align: center;
  max-width: 400px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;
